export default function ammendChannels(template,info){

  let { channelGroupStructure, regionLocation, textLocation, scalebarLocation } = info;
  let copy = JSON.parse(JSON.stringify(template));
  copy.channelGroupStructure = channelGroupStructure;

  if( regionLocation ){


    if( regionLocation === "none" ){
      delete copy.regions;
    }else{

      Object.keys(copy.regions[0]).forEach(key => {
        let regionMap = copy.regions[0][key];
        //regionMap.location = regionLocation.location;
        regionMap.style = {

          padding:1,
          borderWidth:1,
          borderStyle:'solid',
          borderColor:'white',

        }

        if( regionMap.location ) {
          regionMap.style.maxWidth='50%';
          regionMap.style.maxHeight='50%';
        }else{

          regionMap.style.width='100%';
          regionMap.style.height='100%';

        }

      });
    }
  }


  if( textLocation ){


    if( textLocation === "none" ){
      delete copy.text;
    }else{

      copy.text = [{applyAllChannels:{
        location:textLocation.location,
        label:"Label",
        style:{ fontWeight:"bold", background:"black" },
        functions:{ "style.color":"=channelColor" }
      },
        
      }]
    }

  }else{
  }

  if( scalebarLocation ){

    if( scalebarLocation === "none" ){
      delete copy.scalebar;
    }else{


      copy.scalebar = [
        {"012":{
          location:scalebarLocation.location, 
          whiskers:0,
          textPosition:(scalebarLocation.location) || "top",
          thickness:2,
          width:{
            value:40,
            units:"%"
          },
          style:{
            margin:5,
            fontSize:10,
            fontWeight:'bold',
            color:'white',
          }
        }}]
    }
  }

  return copy;
}


